export const ACCOUNTS_RECEIVABLE_SALES_JOURNAL_REPORT = `report/invoice_report`;
